import React from 'react';
import { Button } from 'tea-component';
import { IMetricOption, TSelectedMetrics } from '../_type';

interface IMetricSelectorProps {
  options: IMetricOption[];
  selectedValues: TSelectedMetrics;
  onToggle: (value: string) => void;
  className?: string;
}

/**
 * 指标选择器组件
 */
const MetricSelector: React.FC<IMetricSelectorProps> = ({
  options,
  selectedValues,
  onToggle,
  className,
}) => {

  if (options.length === 0) {
    return null;
  }

  return (
    <div className={`dba-download-settings-item ${className}`}>
      <div className="dba-download-settings-label">
        Metrics
        {/* <Bubble
          content={formatMessage({ id: 'dba_download_default_selected_tip' })}
          placement="top"
        >
          <span className="dba-download-settings-tip-icon">ℹ️</span>
        </Bubble> */}
      </div>
      <div className="dba-download-settings-tag-list">
        {options.map((option) => {
          const isActive = selectedValues.includes(option.value);
          return (
            <Button
              key={option.value}
              type={isActive ? 'primary' : 'weak'}
              className={`dba-download-settings-tag ${isActive ? 'dba-download-settings-tag--active' : ''}`}
              onClick={() => onToggle(option.value)}
            >
              <span className="dba-download-settings-tag-text">{option.text}</span>
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default MetricSelector;

